module.exports = __webpack_public_path__ + "img/govt.0b7a97db.jpeg";